type MapStop = {
  id: number;
  sequence?: number;
  lat?: number | false;
  lng?: number | false;
  name?: string;
  picking_name?: string;
  address?: string;
  status?: string;
};

export type RouteMapDataPayload = {
  depot?: { lat?: number | false; lng?: number | false; name?: string };
  stops?: MapStop[];
  polyline?: Array<{ lat?: number; lng?: number }>;
};

const routeMapDataCache = new Map<number, RouteMapDataPayload>();

export function getCachedRouteMapData(
  routeId: number
): RouteMapDataPayload | undefined {
  return routeMapDataCache.get(routeId);
}

export function setCachedRouteMapData(
  routeId: number,
  data: RouteMapDataPayload
): void {
  routeMapDataCache.set(routeId, data);
}

export function invalidateRouteMapDataCache(routeId?: number): void {
  if (routeId == null) {
    routeMapDataCache.clear();
    return;
  }
  routeMapDataCache.delete(routeId);
}
